import React from 'react';
import { TextFieldProps } from '@mui/material';
import { TextFieldContainer } from './TextField.style';

export type ITextFieldProps = TextFieldProps & {
  
}

const TextField: React.FC<ITextFieldProps> = (props): JSX.Element => {
  const { ...textFieldProps} = props;
  return(
    <TextFieldContainer {...textFieldProps}/>
  );
}

export default TextField;